import cn from "classnames";
import CopyCoordinates from "components/shared/copyCoordinates";
import DropdownBtn from "components/shared/dropdown";
import TruncatedString from "components/shared/truncatedString";
import TypeOptions from "components/shared/typeOptionsShow";
import { formatExtendedProp } from "helpers/bid";
import { formatDateTimezone } from "helpers/bidpoint";
import { dateTimeToView, humanizedTimeDiff } from "helpers/date";
import {
    bidPointOptionFlags,
    bidPointOptionFlagsEnum,
    bidPointTypes,
    bidPointTypesEnum,
    featureModuleTypesEnum,
} from "helpers/enums";
import { isFilledObj } from "helpers/form";
import { paths } from "helpers/paths";
import { enumLabel, flagVal, formatNumber } from "helpers/system";
import compact from "lodash/compact";
import moment from "moment";
import Tooltip from "rc-tooltip";
import React, { Component } from "react";
import SetEstimatedDateAsPlanned from "./setEstimatedDateAsPlanned";

const estimatedDateAsPlannedFlagVal = flagVal(bidPointOptionFlags, bidPointOptionFlagsEnum.EstimatedDateAsPlanned);

const calculationOrder = [
    ["enteredAtByLogist", "loadUnloadedAtByLogist"],
    ["autoEnteredAt", "autoLeavedAt"],
];

const TooltipWrappedTime = (props) => {
    const { enterCalculationTime, leaveCalculationTime, dateName } = props;
    if (enterCalculationTime === dateName || leaveCalculationTime === dateName) {
        return (
            <Tooltip
                overlayClassName="b-timeline-point__date--tooltip"
                placement="bottom"
                overlay="Дата используется для расчетов"
            >
                {props.children}
            </Tooltip>
        );
    } else {
        return props.children;
    }
};

export default class TimelinePoint extends Component {
    state = {
        opened: false,
    };

    constructor(props) {
        super(props);
        const {
            enteredAt,
            planEnterDateOffset,
            secondaryPlanEnterDateOffset,
            loadUnloadedAt,
            planLeaveDateOffset,
            autoEnteredAt,
            autoLeavedAt,
            enteredAtByLogist,
            loadUnloadedAtByLogist,
        } = this.props.point;
        const { workRestInfo, manualEstimatedLeaveDate } = this.props;
        const estimatedDate = manualEstimatedLeaveDate
            ? moment(manualEstimatedLeaveDate).subtract(workRestInfo.maxLoadUnloadPeriod, "hours").format()
            : this.props.estimatedDate;

        this.planDateToCheckLateness =
            secondaryPlanEnterDateOffset && planLeaveDateOffset
                ? moment.min(moment(secondaryPlanEnterDateOffset), moment(planLeaveDateOffset))
                : moment(secondaryPlanEnterDateOffset || planEnterDateOffset);

        this.lateFactEnter =
            planEnterDateOffset && enteredAt && moment(enteredAt) > moment(this.planDateToCheckLateness);
        this.lateAutoEnter =
            planEnterDateOffset && autoEnteredAt && moment(autoEnteredAt) > moment(this.planDateToCheckLateness);

        this.lateEstimatedDate =
            planEnterDateOffset && estimatedDate && moment(estimatedDate) > moment(this.planDateToCheckLateness);
        this.lateEnteredAtByLogist =
            planEnterDateOffset &&
            enteredAtByLogist &&
            moment(enteredAtByLogist) > moment(this.planDateToCheckLateness);

        this.lateFactLeave =
            planLeaveDateOffset && loadUnloadedAt && moment(loadUnloadedAt) > moment(planLeaveDateOffset);
        this.lateAutoLeave = planLeaveDateOffset && autoLeavedAt && moment(autoLeavedAt) > moment(planLeaveDateOffset);
        this.lateManualEstimatedLeaveDate =
            planEnterDateOffset &&
            manualEstimatedLeaveDate &&
            moment(manualEstimatedLeaveDate) > moment(planLeaveDateOffset);
        this.lateLoadUnloadedAtByLogist =
            planLeaveDateOffset &&
            loadUnloadedAtByLogist &&
            moment(loadUnloadedAtByLogist) > moment(planLeaveDateOffset);

        const getPointPresentKey = (keys) => keys.find((keys) => !!this.props.point[keys[0]]);
        this.calculationTime = getPointPresentKey(calculationOrder) || [];
    }

    completedRoute = () => {
        const { enteredAt, autoEnteredAt, loadUnloadedAt, autoLeavedAt, enteredAtByLogist, loadUnloadedAtByLogist } =
            this.props.point;
        const { nextPoint } = this.props;
        if (!(enteredAt || autoEnteredAt || enteredAtByLogist) || !nextPoint) {
            return null;
        }
        if (
            (enteredAt || autoEnteredAt || enteredAtByLogist) &&
            !(loadUnloadedAt || autoLeavedAt || loadUnloadedAtByLogist)
        ) {
            return null;
        }
        const height =
            nextPoint.enteredAt || nextPoint.autoEnteredAt || nextPoint.enteredAtByLogist || nextPoint.manualStartAt
                ? 100
                : 50;
        return (
            <>
                <div className="b-timeline-point__line--green" style={{ height: `${height}%` }} />
                {!(
                    nextPoint.enteredAt ||
                    nextPoint.autoEnteredAt ||
                    nextPoint.enteredAtByLogist ||
                    nextPoint.manualStartAt
                ) && <div className="b-timeline-point__line--car" />}
            </>
        );
    };

    pointClass = (isLate, isCalculationTime = false) => {
        return cn("b-timeline-point__date--value", {
            "text-danger": isLate,
            "text-success": !isLate,
            "font-weight-bold": isCalculationTime,
        });
    };

    timeDiff = (planTime, factTime) => {
        const timeDiff = humanizedTimeDiff(planTime, factTime);
        if (!timeDiff) {
            return null;
        }
        return <div>({timeDiff})</div>;
    };

    openForceComplete = () => {
        const { modal, bid, getItem, pointsOrderedByRoute } = this.props;
        modal({
            name: "forceComplete",
            title: "Завершение заявки",
            bid,
            pointsOrderedByRoute,
            windowMod: "wide",
            callback: () => getItem(),
        });
    };

    editBtn = () => {
        if (this.props.roles.isTruckingOrganizationExtendedViewer) {
            return null;
        }
        const { canSetEstimatedDateAsPlanned, letter, bid, canPredictPoint, predictBidPoint } = this.props;
        const { enteredAt, autoEnteredAt, planEnterDateOffset, id } = this.props.point;
        const items = [];
        if (this.props.canReorderBidPoints) {
            items.push({
                text: "Изменить порядок точек",
                action: () => {
                    const { modal, bid, point, updateBidPointsOrder, hasPlanEmptyMileageBidModule } = this.props;
                    return modal({
                        name: "bidPointsOrder",
                        title: "Изменить порядок точек",
                        windowMod: "sm",
                        bidPoints: bid.bidPoints,
                        selectedPointId: point.id,
                        hasPlanEmptyMileageBidModule,
                        onSave: updateBidPointsOrder,
                    });
                },
            });
        }
        if (enteredAt || autoEnteredAt) {
            items.push({
                text: "Выбрать период нахождения",
                action: () =>
                    this.props.modal({
                        name: "changePointVisit",
                        title: "Выберите период посещения точки",
                        bidPointId: this.props.point.id,
                        windowMod: "print",
                        callback: () => this.props.getItem(),
                    }),
            });
        }
        if (this.props.canSeeEditPointDatesBtn) {
            const { forceCompleteOnLastPointManualDates } = this.props;
            items.push({
                text: forceCompleteOnLastPointManualDates
                    ? "Завершить заявку вручную"
                    : "Корректировать фактические даты",
                action: () => {
                    if (forceCompleteOnLastPointManualDates) {
                        return this.openForceComplete();
                    }

                    const { modal, bid, getItem, point } = this.props;
                    return modal({
                        name: "setBidPointDates",
                        title: "Изменить фактические даты",
                        windowMod: "sm",
                        callback: () => getItem(),
                        bidPoint: point,
                        bid,
                    });
                },
            });
        }
        if (this.props.canSetBidEstimatedLeaveDate) {
            items.push({
                text: "Редактировать расчетное время выезда",
                action: () => {
                    const { modal, bid, getItem, point, manualEstimatedLeaveDate, estimationComment } = this.props;
                    return modal({
                        name: "setBidEstimatedLeaveDate",
                        title: "Изменить расчетное время выезда",
                        windowMod: "sm",
                        refreshData: () => getItem(),
                        bidPoint: point,
                        manualEstimatedLeaveDate,
                        comment: estimationComment,
                        bid,
                    });
                },
            });
        }
        if (canSetEstimatedDateAsPlanned) {
            items.push({
                text: "Изменить плановую дату на расчетную",
                action: () => {
                    const { modal, getItem } = this.props;
                    return modal({
                        name: "default",
                        title: "Изменение планового времени точки",
                        CustomBody: (modalProps) => (
                            <SetEstimatedDateAsPlanned
                                {...modalProps}
                                getItem={getItem}
                                letter={letter}
                                id={id}
                                bid={bid}
                                planEnterDateOffset={planEnterDateOffset}
                            />
                        ),
                    });
                },
            });
        }
        if (canPredictPoint) {
            items.push({
                text: "Предсказать точку заявки",
                action: () => predictBidPoint(this.props.point.id),
            });
        }
        if (items.length === 0) {
            return null;
        }
        const props = {
            withoutChevron: true,
            text: <i className="icon-uEA10-pen" />,
            cname: "b-timeline-point__settings",
            align: "end",
            wrapCname: "b-timeline-point__settings--wrap",
            items,
        };
        return <DropdownBtn {...props} />;
    };

    tipProps = (dateName) => {
        if (this.props.point[dateName] && this.calculationTime.includes(dateName)) {
            return { "data-tip": true, "data-for": "calculationTime" };
        } else {
            return {};
        }
    };

    calculationIcon = (dateName) => {
        if (this.calculationTime.includes(dateName)) {
            return (
                <>
                    &nbsp;
                    <i className="icon-uEA80-calculator" />
                </>
            );
        } else {
            return null;
        }
    };

    renderExtendedProperties = () => {
        const { extendedProperties } = this.props.point;
        const { extendedPropertiesConfig, index } = this.props;
        if (!isFilledObj(extendedProperties)) {
            return null;
        }
        return extendedPropertiesConfig.bidPoint.map((prop) => {
            const valueObj = extendedProperties.find((item) => item.propertyName === prop.propertyName);
            return (
                <div
                    key={prop.id}
                    className="b-timeline-point__city--full"
                    data-point-extended-props={index}
                    style={prop.order ? { order: prop.order } : {}}
                >
                    {prop.displayName}: {valueObj ? formatExtendedProp(valueObj.value, prop.typeCode) : ""}
                </div>
            );
        });
    };

    renderPreviousBidId = () => {
        const { type } = this.props.point;
        if (type !== bidPointTypesEnum.StartPoint) {
            return null;
        }
        const { bid } = this.props;
        return (
            <div className="b-timeline-point__city--full" data-point-previous-bid-id={this.props.index}>
                Предыдущая заявка для точки 0:{" "}
                <a target="_blank" rel="noopener noreferrer" href={paths.bidShow("bid", bid.startPointBidId)}>
                    {bid.startPointBidId}
                </a>
            </div>
        );
    };

    renderTypeOptions = () => {
        const { typeOptions } = this.props.point;
        if (!typeOptions || typeOptions.length === 0) {
            return null;
        }
        const { enums, userEntityOptions } = this.props;
        const props = { typeOptions, enums, userEntityOptions };
        return <TypeOptions inline {...props} />;
    };

    render() {
        const {
            geozone: { city, village, county, address, location },
            type,
            enteredAt,
            loadUnloadedAt,
            planLeaveDateOffset,
            planEnterDateOffset,
            secondaryPlanEnterDateOffset,
            autoEnteredAt,
            autoLeavedAt,
            comment,
            enteredAtByLogist,
            loadUnloadedAtByLogist,
            client,
            contactPerson,
            counterparty,
            extendedProperties,
            loadOptions,
            customPointType,
            axisLoadAfterLeaving,
            planDistance,
            factDistance,
            servicePoint,
            typeOptions,
            documentsReceivedAt,
            intOptions,
            externalCity,
        } = this.props.point;
        const estimatedDateAsPlanned = (intOptions & estimatedDateAsPlannedFlagVal) === estimatedDateAsPlannedFlagVal;

        const { averageValue } = axisLoadAfterLeaving || {};
        const { letter, nextPoint, manualEstimatedLeaveDate, workRestInfo, loadUnloadType, profile, index } =
            this.props;
        const estimatedDate = manualEstimatedLeaveDate
            ? moment(manualEstimatedLeaveDate).subtract(workRestInfo.maxLoadUnloadPeriod, "hours").format()
            : this.props.estimatedDate;
        const typeTitle =
            type === bidPointTypesEnum.CustomPoint ? customPointType.name : enumLabel(bidPointTypes, type);
        const utcTimezone = formatDateTimezone({ planEnterDateOffset });
        const circleCnames = cn("b-timeline-point__circle", {
            "b-timeline-point__circle--green": autoEnteredAt || enteredAtByLogist,
            "b-timeline-point__circle--half":
                (autoEnteredAt || enteredAtByLogist) && !(autoLeavedAt || loadUnloadedAtByLogist) && nextPoint,
        });
        const planDistanceEnabled = profile.availableFeatureModules.includes(
            featureModuleTypesEnum.PlanDistanceBetweenPoints,
        );
        const axisLoadMonitoringEnabled = profile.availableFeatureModules.includes(
            featureModuleTypesEnum.AxisLoadMonitoring,
        );
        const documentAssignmentEnabled = profile.availableFeatureModules.includes(
            featureModuleTypesEnum.DocumentAssignment,
        );
        return (
            <div className="b-timeline-point">
                <div className="b-timeline-point__figure">
                    <div className={circleCnames}>
                        <div className="b-timeline-point__circle--text">
                            {type === bidPointTypesEnum.ServicePoint ? <i className="icon-uEA97-wrench" /> : letter}
                        </div>
                    </div>
                    <div className="b-timeline-point__line">{this.completedRoute()}</div>
                </div>
                <div className="b-timeline-point__data">
                    <div className="b-timeline-point__city">
                        <div className="pb-1 b-timeline-point__city--info">
                            <div>
                                {(client ||
                                    contactPerson ||
                                    counterparty ||
                                    (extendedProperties && extendedProperties.length > 0) ||
                                    (typeOptions && typeOptions.length > 0) ||
                                    (loadOptions && loadOptions.length > 0)) && (
                                    <span
                                        className="b-timeline-point__more-link"
                                        onClick={() => this.setState({ opened: !this.state.opened })}
                                    >
                                        {this.state.opened ? (
                                            <i className="icon-uEA72-chevron-down" />
                                        ) : (
                                            <i className="icon-uEA72-chevron-down rotated" />
                                        )}
                                    </span>
                                )}
                                <span
                                    className="b-timeline-point__city--name"
                                    onClick={() =>
                                        this.props.mergeMapViewport({
                                            center: [...location.coordinates].reverse(),
                                            zoom: 12,
                                        })
                                    }
                                >
                                    {city || village || county}
                                </span>
                                <small className="b-timeline-point__city--timezone">&nbsp;{utcTimezone}</small>
                            </div>
                            <div className="b-timeline-point__city--type-wrap c-dropd">
                                {servicePoint && servicePoint.withoutCargo && (
                                    <small className="b-timeline-point__city--danger mr-1">Без груза</small>
                                )}
                                <small className="b-timeline-point__city--type">{typeTitle}</small>
                                {this.editBtn()}
                            </div>
                        </div>
                        <div className="b-timeline-point__city--full" data-point-address={index}>
                            <CopyCoordinates coordinates={[...location.coordinates].reverse().join(", ")} />
                            {address}
                        </div>
                        {this.renderPreviousBidId()}
                        {comment && (
                            <div className="b-timeline-point__city--full" data-point-comment={index}>
                                Комментарий: <TruncatedString text={comment} />
                            </div>
                        )}
                        {externalCity && (
                            <div className="b-timeline-point__city--full" data-point-external-city={index}>
                                Город для 1С: {externalCity}
                            </div>
                        )}
                        {axisLoadMonitoringEnabled && (
                            <div className="b-timeline-point__city--full" data-point-axis-load={index}>
                                Средний вес: {averageValue ? `${formatNumber(averageValue)} т.` : "Не определен"}
                            </div>
                        )}
                        {servicePoint?.externalId && (
                            <div className="b-timeline-point__city--full" data-test-id="service-point-id">
                                Номер сервисной работы: {servicePoint?.externalId}
                            </div>
                        )}
                        {documentAssignmentEnabled && documentsReceivedAt && (
                            <div className="b-timeline-point__city--full" data-point-document-received-at={index}>
                                Получил документы: {dateTimeToView(documentsReceivedAt)}
                            </div>
                        )}
                        {this.state.opened && (
                            <>
                                {client && (
                                    <div className="b-timeline-point__city--full" data-point-client={index}>
                                        {`Клиент: ${client}`}
                                    </div>
                                )}
                                {contactPerson && (
                                    <div className="b-timeline-point__city--full" data-point-contact-person={index}>
                                        {`Контактное лицо: ${compact([contactPerson.name, contactPerson.phoneNumber]).join(", ")}`}
                                    </div>
                                )}
                                {counterparty && (
                                    <div className="b-timeline-point__city--full" data-point-counterparty={index}>
                                        {`${type === bidPointTypesEnum.LoadPoint ? "Грузоотправитель" : "Грузополучатель"}: ${counterparty.name}`}
                                    </div>
                                )}
                                {loadOptions && (
                                    <div className="b-timeline-point__city--full" data-point-load-options={index}>
                                        {`${type === bidPointTypesEnum.LoadPoint ? "Типы погрузки" : "Типы разгрузки"}: ${loadOptions
                                            .map((option) => enumLabel(loadUnloadType, option.id))
                                            .join(", ")}`}
                                    </div>
                                )}
                                <div className="d-flex flex-column">
                                    {this.renderExtendedProperties()}
                                    {this.renderTypeOptions()}
                                </div>
                            </>
                        )}
                    </div>
                    <div className="b-timeline-point__info">
                        <div className="b-timeline-point__table">
                            <div className="b-timeline-point__date--header" />
                            <div className="b-timeline-point__date--header">Въезд</div>
                            <div className="b-timeline-point__date--header">Выезд</div>
                            <div className="b-timeline-point__date--name">
                                Плановый
                                {estimatedDateAsPlanned && (
                                    <Tooltip overlay="Дата была изменена на расчетную">
                                        <i className="icon-uEAAF-clock pl-1 inline-icon" />
                                    </Tooltip>
                                )}
                            </div>
                            <div className="b-timeline-point__date--value" data-test-id="point-plan-enter-date">
                                {dateTimeToView(planEnterDateOffset)}
                                {secondaryPlanEnterDateOffset && (
                                    <>
                                        <br />
                                        {dateTimeToView(secondaryPlanEnterDateOffset)}
                                    </>
                                )}
                            </div>
                            <div className="b-timeline-point__date--value" data-test-id="point-plan-leave-date">
                                {dateTimeToView(planLeaveDateOffset)}
                            </div>
                            {(enteredAt || loadUnloadedAt) && (
                                <>
                                    <div className="b-timeline-point__date--name">Данные от водителя</div>
                                    <TooltipWrappedTime
                                        enterCalculationTime={this.enterCalculationTime}
                                        leaveCalculationTime={this.leaveCalculationTime}
                                        dateName="enteredAt"
                                    >
                                        <div
                                            className={this.pointClass(
                                                this.lateFactEnter,
                                                this.enterCalculationTime === "enteredAt",
                                            )}
                                            data-test-id="point-enter-date"
                                        >
                                            {dateTimeToView(enteredAt)}
                                            {this.timeDiff(this.planDateToCheckLateness, enteredAt)}
                                        </div>
                                    </TooltipWrappedTime>
                                    <TooltipWrappedTime
                                        enterCalculationTime={this.enterCalculationTime}
                                        leaveCalculationTime={this.leaveCalculationTime}
                                        dateName="loadUnloadedAt"
                                    >
                                        <div
                                            className={this.pointClass(
                                                this.lateFactLeave,
                                                this.leaveCalculationTime === "loadUnloadedAt",
                                            )}
                                            data-test-id="point-load-unload-date"
                                        >
                                            {dateTimeToView(loadUnloadedAt)}
                                            {this.timeDiff(planLeaveDateOffset, loadUnloadedAt)}
                                        </div>
                                    </TooltipWrappedTime>
                                </>
                            )}
                            {(autoEnteredAt || autoLeavedAt) && (
                                <>
                                    <div className="b-timeline-point__date--name">Фактический - GPS</div>
                                    <TooltipWrappedTime
                                        enterCalculationTime={this.enterCalculationTime}
                                        leaveCalculationTime={this.leaveCalculationTime}
                                        dateName="autoEnteredAt"
                                    >
                                        <div
                                            className={this.pointClass(
                                                this.lateAutoEnter,
                                                this.enterCalculationTime === "autoEnteredAt",
                                            )}
                                            data-test-id="point-auto-enter-date"
                                        >
                                            {dateTimeToView(autoEnteredAt)}
                                            {this.calculationIcon("autoEnteredAt")}
                                            {this.timeDiff(this.planDateToCheckLateness, autoEnteredAt)}
                                        </div>
                                    </TooltipWrappedTime>
                                    <TooltipWrappedTime
                                        enterCalculationTime={this.enterCalculationTime}
                                        leaveCalculationTime={this.leaveCalculationTime}
                                        dateName="autoLeavedAt"
                                    >
                                        <div
                                            className={this.pointClass(
                                                this.lateAutoLeave,
                                                this.leaveCalculationTime === "autoLeavedAt",
                                            )}
                                            data-test-id="point-auto-leave-date"
                                        >
                                            {dateTimeToView(autoLeavedAt)}
                                            {this.calculationIcon("autoLeavedAt")}
                                            {this.timeDiff(planLeaveDateOffset, autoLeavedAt)}
                                        </div>
                                    </TooltipWrappedTime>
                                </>
                            )}
                            {(enteredAtByLogist || loadUnloadedAtByLogist) && (
                                <>
                                    <div className="b-timeline-point__date--name">Ручной</div>
                                    <TooltipWrappedTime
                                        enterCalculationTime={this.enterCalculationTime}
                                        leaveCalculationTime={this.leaveCalculationTime}
                                        dateName="enteredAtByLogist"
                                    >
                                        <div
                                            className={this.pointClass(
                                                this.lateEnteredAtByLogist,
                                                this.enterCalculationTime === "enteredAtByLogist",
                                            )}
                                            data-test-id="point-enter-date-by-logist"
                                        >
                                            {dateTimeToView(enteredAtByLogist)}
                                            {this.calculationIcon("enteredAtByLogist")}
                                            {this.timeDiff(this.planDateToCheckLateness, enteredAtByLogist)}
                                        </div>
                                    </TooltipWrappedTime>
                                    <TooltipWrappedTime
                                        enterCalculationTime={this.enterCalculationTime}
                                        leaveCalculationTime={this.leaveCalculationTime}
                                        dateName="loadUnloadedAtByLogist"
                                    >
                                        <div
                                            className={this.pointClass(
                                                this.lateLoadUnloadedAtByLogist,
                                                this.leaveCalculationTime === "loadUnloadedAtByLogist",
                                            )}
                                            data-test-id="point-load-unload-date-by-logist"
                                        >
                                            {dateTimeToView(loadUnloadedAtByLogist)}
                                            {this.calculationIcon("loadUnloadedAtByLogist")}
                                            {this.timeDiff(planLeaveDateOffset, loadUnloadedAtByLogist)}
                                        </div>
                                    </TooltipWrappedTime>
                                </>
                            )}
                            {((estimatedDate && !(autoEnteredAt || enteredAtByLogist)) || manualEstimatedLeaveDate) &&
                                !(autoLeavedAt || loadUnloadedAtByLogist) && (
                                    <>
                                        <div className="b-timeline-point__date--name">Расчетный</div>
                                        <div
                                            className={this.pointClass(this.lateEstimatedDate)}
                                            data-test-id="point-estimated-date"
                                        >
                                            {dateTimeToView(estimatedDate)}
                                        </div>
                                        <div
                                            className={this.pointClass(this.lateManualEstimatedLeaveDate)}
                                            data-test-id="point-manual-estimated-date"
                                        >
                                            {dateTimeToView(manualEstimatedLeaveDate)}
                                        </div>
                                    </>
                                )}
                        </div>
                        {planDistanceEnabled && planDistance && (
                            <>
                                <hr />
                                <div className="d-flex justify-content-around">
                                    <div>
                                        <div className="b-timeline-point__date--name">Плановый км</div>
                                        <div data-test-id="point-plan-distance">
                                            {formatNumber(Math.round(planDistance / 1000))} км
                                        </div>
                                    </div>
                                    <div>
                                        <div className="b-timeline-point__date--name">Фактический км</div>
                                        {factDistance ? (
                                            <div data-test-id="point-fact-distance">
                                                {formatNumber(Math.round(factDistance / 1000))} км
                                            </div>
                                        ) : (
                                            "-"
                                        )}
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}
